import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Select, SelectProps, SelectOptionWithGroup } from 'tea-component';

import { renderImgText } from './MultipleSelector';
import { getDataSourceInfo } from '@/pages/intelligence/utils/getDataSourceInfo';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import type {
  IMobileDataSource,
  IPCDataSource,
  IConsoleDataSource,
} from '@/pages/intelligence/utils/getDataSourceInfo';

export const renderSinglePlatformOptions = (entityType: IGameType, platforms: string[]): IPlatformOption[] => {
  if (!Array.isArray(platforms)) return [];
  return platforms.map((platform) => {
    const { name, icon } = getDataSourceInfo(entityType, platform);
    const text = renderImgText(name, icon);
    return {
      value: platform,
      label: name,
      text,
    };
  });
};

interface IPlatformOption extends SelectOptionWithGroup {
  label: string;
}

interface ISinglePlatformSelectProps extends IBaseProps, SelectProps {
  // mobile、pc、console 需要根据entityType 取对应的platform信息（name，icon）
  entityType: IGameType;
  platforms: IMobileDataSource[] | IPCDataSource[] | IConsoleDataSource[];
}

const SinglePlatformSelect: React.FC<ISinglePlatformSelectProps> = (props) => {
  const { style, className, disabled, entityType = 'mobile', platforms, value, onChange } = props;

  const { formatMessage } = useIntl();

  const placeholder = formatMessage({ id: 'dbi_please_select' });

  const options = renderSinglePlatformOptions(entityType, platforms);

  const renderButton = () => {
    const valueUI = (() => {
      if (!value) return placeholder;
      const option = options?.find((item) => item?.value === value);
      return option?.text ?? placeholder;
    })();

    return (
      <div className="dbi-select-button">
        <span className="select-button-text">{`${formatMessage({ id: 'dbi_platform' })} `}</span>
        <span className="select-button-value">{valueUI}</span>
      </div>
    );
  };

  const handleChange = (payload: string, context: any) => {
    onChange?.(payload, context);
  };

  return (
    <Select
      style={style}
      className={classnames('select-item', className)}
      size="m"
      appearance="button"
      matchButtonWidth
      disabled={disabled}
      button={renderButton()}
      options={options}
      value={value}
      onChange={handleChange}
    />
  );
};

export default SinglePlatformSelect;
